import React from 'react';

import type { ManufacturerCardCheckboxProps } from '../../types/ManufacturerCardCheckboxProps';
import Checkbox from '../../../../ui/Checkbox/Checkbox';
import { TEXT_CONTENT_IDS } from '../../../../utils/element-ids';

const ManufacturerCardCheckbox: React.FC<
  ManufacturerCardCheckboxProps
> = ({ id, onChange, value }) => {
  return (
    <Checkbox
      id={id}
      value={value}
      label="Manufacturer copay card"
      testId={TEXT_CONTENT_IDS.MANUFACTURER_CARD_LABEL}
      onChange={onChange}
    />
  );
};

export default ManufacturerCardCheckbox;
